import { render } from "./BleConnector.vue?vue&type=template&id=502b133a"
import script from "./BleConnector.vue?vue&type=script&lang=js"
export * from "./BleConnector.vue?vue&type=script&lang=js"
script.render = render

export default script